module.exports = __webpack_public_path__ + "src/img/artist/work06_2.jpg?37d6b3fe4b0eac51786408f3053363bd";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work06_2.jpg
// module id = 157
// module chunks = 0